import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { createSession } from '../services/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login');
          return;
        }

        const response = await createSession(sessionId);
        const user = response.data.user;
        const token = response.data.session_token;

        // Store token and user data
        if (token) {
          localStorage.setItem('session_token', token);
        }
        localStorage.setItem('user', JSON.stringify(user));

        // Check if there's a pending doctor registration
        const pendingRegistration = localStorage.getItem('pending_doctor_registration');
        if (pendingRegistration) {
          navigate('/doctor/register', { state: { user }, replace: true });
          return;
        }

        // Navigate based on role
        if (user.role === 'super_admin') {
          navigate('/admin/dashboard', { state: { user }, replace: true });
        } else if (user.role === 'doctor') {
          navigate('/doctor/dashboard', { state: { user }, replace: true });
        } else {
          navigate('/patient/dashboard', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('Session processing error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0F2A44] mx-auto"></div>
        <p className="mt-4 text-[#262626] font-public">Authenticating...</p>
      </div>
    </div>
  );
}